export default "/images/vendor/flag-icon-css/flags/1x1/nz.svg?0dcf8cf746e1d65a4528f729ab25e8c5";